import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  menuItem?: any;
  isInnerCategory?: boolean;
  areLastChildren?: boolean;
}
interface Emits {
  (e: 'open-category'): void;
  (e: 'close-menu'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMainMenuMobileItem',
  props: {
    menuItem: { default: () => ({}) },
    isInnerCategory: { type: Boolean, default: false },
    areLastChildren: { type: Boolean, default: false }
  },
  emits: ["open-category", "close-menu"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'open-category'): void;
  (e: 'close-menu'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menuItem: any, isInnerCategory: boolean, areLastChildren: boolean };




const hasChildren = computed(() => Boolean(props.menuItem.children?.length));

const openCategory = () => {
  emit('open-category');
};

const closeMenu = () => {
  emit('close-menu');
};

const paddingClasses = computed(() => {
  if (props.isInnerCategory && !hasChildren.value) return 'py-4';
  if (!props.isInnerCategory && !hasChildren.value) return 'py-6';
  return '';
});

return { __sfc: true,props, emit, hasChildren, openCategory, closeMenu, paddingClasses }
}

})